import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCurrentTimestamp } from "../../utils/DateUtils";
import CustomerService from "../../rest/customerService";
import { formatCurrency } from "../../utils/CurrencyUtils";
import CustomButton from "../lib/customButton";


const ExpenseModal = ({ isOpen, onClose, client }) => {
    const [editedCredit, setEditedCredit] = useState("");
    const [expenseMotive, setExpenseMotive] = useState("");
    const [loading, setLoading] = useState(false);

    const initialCredit = Number(client?.credit || 0);

    useEffect(() => {
        if (!isOpen) {
            setEditedCredit("");
            setExpenseMotive("");
            setLoading(false);
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleSaveExpense = async () => {
        const valueToRemove = Number(editedCredit || 0);
        const newValue = initialCredit - valueToRemove;

        if (valueToRemove <= 0) {
            alert("Informe um valor válido para remoção.");
            return;
        }

        if (!expenseMotive) {
            alert("Informe o motivo da correção.");
            return;
        }

        setLoading(true);

        const updatedCreditCharge = {
            paymentMethod: "ADMIN",
            value: valueToRemove,
            received_value: valueToRemove,
            credit_afterwards: newValue,
            client_code: client.client_code,
            customer_id: client.login,
            transactionDate: getCurrentTimestamp(),
            transaction_type: "Credit Expense",
            observations: expenseMotive,
            transactionSource: "MANUAL"
        };

        try {
            if (client.role === 'STUDENT') {
                await CustomerService.updateStudentCredit(
                    client.login,
                    {
                        login: client.login,
                        credit: newValue.toFixed(2),
                        client_code: client.client_code
                    },
                    updatedCreditCharge
                );
            } else if (client.role === 'EMPLOYEE') {
                await CustomerService.updateEmployeeCredit(
                    client.login,
                    {
                        login: client.login,
                        credit: newValue.toFixed(2),
                        clientCode: client.clientCode
                    },
                    updatedCreditCharge
                );
            }

            toast.success("Correção de saldo realizada!");
            onClose();

        } catch (error) {
            console.error(error);
            toast.error("Erro ao realizar correção.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-60 bg-black/50 flex items-center justify-center animate-in fade-in duration-200">
            <div className="bg-white rounded-lg w-full max-w-xl p-8 shadow-lg transform transition-all">

                <h2 className="text-2xl font-semibold text-center mb-6">Correção de Crédito (Remoção)</h2>

                <div className="space-y-4">
                    <p className="text-lg">
                        Valor atual: <span className={initialCredit >= 0 ? "text-green-600 font-bold" : "text-red-500 font-bold"}>{formatCurrency(initialCredit)}</span>
                    </p>

                    <div className="flex items-center justify-between gap-4">
                        <span>Valor a ser removido</span>
                        <input
                            type="number"
                            min="0.01"
                            step="0.05"
                            className="w-1/3 p-2 border-b border-gray-300 focus:border-red-500 outline-none transition-colors"
                            onChange={(e) => setEditedCredit(e.target.value)}
                            placeholder="R$ 0,00"
                        />
                    </div>

                    <div className="flex items-center justify-between gap-4 mt-4">
                        <span>Motivo</span>
                        <select
                            className="w-2/3 p-2 rounded-md text-sm bg-white shadow-sm border border-slate-300 focus:ring-1 focus:ring-blue-500 outline-none"
                            value={expenseMotive}
                            onChange={(e) => setExpenseMotive(e.target.value)}
                        >
                            <option value="">Selecione uma opção...</option>
                            <option value="Recarga feita incorretamente.">Recarga feita incorretamente.</option>
                            <option value="Ajuste administrativo.">Ajuste administrativo.</option>
                            <option value="Outro.">Outro...</option>
                        </select>
                    </div>
                </div>

                <div className="flex justify-end gap-4 mt-8">
                    <CustomButton
                        buttonType="save"
                        text={loading ? "Processando..." : "Finalizar"}
                        onClick={handleSaveExpense}
                        disabled={loading}
                        fullWidth
                    />
                    <CustomButton
                        buttonType="cancel"
                        text="Cancelar"
                        onClick={onClose}
                        disabled={loading}
                        fullWidth
                    />
                </div>

            </div>
        </div>
    );
};

export default ExpenseModal;